import { Validators } from '@angular/forms';
import { TypedFormControl, TypedFormGroup } from '@principle-theorem/ng-shared';
import {
  IAddressMetadata,
  ITag,
  type IContactDetails,
} from '@principle-theorem/principle-core/interfaces';
import { INamedDocument } from '@principle-theorem/shared';
import { CustomValidators } from '../../forms/custom-validators';

type IContactFormData = Omit<IContactDetails, 'address' | 'metadata'> & {
  address: IAddressMetadata;
  tags: INamedDocument<ITag>[];
};

export class ContactFormGroup extends TypedFormGroup<IContactFormData> {
  constructor() {
    super(
      {
        name: new TypedFormControl('', Validators.required),
        email: new TypedFormControl('', Validators.email),
        address: new TypedFormControl<IAddressMetadata>({ address: '' }),
        phone: new TypedFormControl('', [CustomValidators.phoneNumber]),
        jobTitle: new TypedFormControl(''),
        mobileNumber: new TypedFormControl('', [CustomValidators.phoneNumber]),
        tags: new TypedFormControl<INamedDocument<ITag>[]>([]),
      },
      CustomValidators.requireOneOf(['email', 'address', 'phone'])
    );
  }
}
